import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Contact() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="py-24 relative overflow-hidden" data-id="element-26">
      <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/iycRemxN5BhMge7qhWzZUo/Mold-Damage-Clean-Up-1.jpg")'
    }} data-id="element-27" />
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/95 via-gray-900 to-gray-900/95" data-id="element-28" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-30">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-31">
            <h2 className="text-brand-gold font-bold tracking-wider uppercase mb-2" data-id="element-32">
              {t.contact.tag}
            </h2>
            <h3 className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-33">
              {t.contact.title}
            </h3>
            <p className="text-lg text-gray-300 mb-10" data-id="element-34">{t.contact.desc}</p>

            <div className="space-y-8" data-id="element-35">
              <div className="flex items-start gap-4" data-id="element-36">
                <div className="w-12 h-12 bg-brand-red/20 border border-brand-red/30 rounded-full flex items-center justify-center shrink-0" data-id="element-37">
                  <Phone className="text-brand-gold" size={24} data-id="element-38" />
                </div>
                <div data-id="element-39">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-40">
                    {t.contact.call}
                  </h4>
                  <a href="tel:+13054170530" className="text-gray-300 text-lg hover:text-brand-gold transition-colors block" data-id="element-41">
                    (305) 417-0530
                  </a>
                  <a href="tel:+13057857829" className="text-gray-300 text-lg hover:text-brand-gold transition-colors block" data-id="element-42">
                    (305) 785-7829
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-43">
                <div className="w-12 h-12 bg-brand-red/20 border border-brand-red/30 rounded-full flex items-center justify-center shrink-0" data-id="element-44">
                  <Mail className="text-brand-gold" size={24} data-id="element-45" />
                </div>
                <div data-id="element-46">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-47">
                    {t.contact.email}
                  </h4>
                  <a href="mailto:elitepropertyadjusters@gmail.com" className="text-gray-300 text-lg hover:text-brand-gold transition-colors" data-id="element-48">
                    elitepropertyadjusters@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-49">
                <div className="w-12 h-12 bg-brand-red/20 border border-brand-red/30 rounded-full flex items-center justify-center shrink-0" data-id="element-50">
                  <MapPin className="text-brand-gold" size={24} data-id="element-51" />
                </div>
                <div data-id="element-52">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-53">
                    {t.contact.office}
                  </h4>
                  <a href="https://www.google.com/maps/search/?api=1&query=1758+NE+177th+St+North+Miami+Beach+FL+33162" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-lg hover:text-brand-gold transition-colors" data-id="element-54">
                    1758 NE 177th St.
                    <br data-id="element-55" />
                    North Miami Beach, FL 33162
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-56">
                <div className="w-12 h-12 bg-brand-red/20 border border-brand-red/30 rounded-full flex items-center justify-center shrink-0" data-id="element-57">
                  <Clock className="text-brand-gold" size={24} data-id="element-58" />
                </div>
                <div data-id="element-59">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-60">
                    {t.contact.hours}
                  </h4>
                  <p className="text-gray-300 text-lg whitespace-pre-line" data-id="element-61">
                    {t.contact.hoursDesc}
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/10 backdrop-blur-sm border border-white/10 p-8 md:p-10 rounded-sm" data-id="element-62">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-63">
              {t.contact.form.title}
            </h3>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-64">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-65">
                <div data-id="element-66">
                  <label className="block text-sm font-bold text-gray-300 mb-2" data-id="element-67">
                    {t.contact.form.fn}
                  </label>
                  <input type="text" className="w-full px-4 py-3 rounded-sm bg-white/10 border border-white/20 text-white placeholder-gray-500 focus:border-brand-gold focus:ring-2 focus:ring-brand-gold/20 outline-none transition-all" data-id="element-68" />
                </div>
                <div data-id="element-69">
                  <label className="block text-sm font-bold text-gray-300 mb-2" data-id="element-70">
                    {t.contact.form.ln}
                  </label>
                  <input type="text" className="w-full px-4 py-3 rounded-sm bg-white/10 border border-white/20 text-white placeholder-gray-500 focus:border-brand-gold focus:ring-2 focus:ring-brand-gold/20 outline-none transition-all" data-id="element-71" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-72">
                <div data-id="element-73">
                  <label className="block text-sm font-bold text-gray-300 mb-2" data-id="element-74">
                    {t.contact.form.phone}
                  </label>
                  <input type="tel" className="w-full px-4 py-3 rounded-sm bg-white/10 border border-white/20 text-white placeholder-gray-500 focus:border-brand-gold focus:ring-2 focus:ring-brand-gold/20 outline-none transition-all" data-id="element-75" />
                </div>
                <div data-id="element-76">
                  <label className="block text-sm font-bold text-gray-300 mb-2" data-id="element-77">
                    {t.contact.form.email}
                  </label>
                  <input type="email" className="w-full px-4 py-3 rounded-sm bg-white/10 border border-white/20 text-white placeholder-gray-500 focus:border-brand-gold focus:ring-2 focus:ring-brand-gold/20 outline-none transition-all" data-id="element-78" />
                </div>
              </div>

              <div data-id="element-79">
                <label className="block text-sm font-bold text-gray-300 mb-2" data-id="element-80">
                  {t.contact.form.type}
                </label>
                <select className="w-full px-4 py-3 rounded-sm bg-white/10 border border-white/20 text-white focus:border-brand-gold focus:ring-2 focus:ring-brand-gold/20 outline-none transition-all" data-id="element-81">
                  {t.contact.form.options.map((opt, i) => <option key={i} className="bg-gray-900 text-white" data-id="element-82">
                      {opt}
                    </option>)}
                </select>
              </div>

              <div data-id="element-83">
                <label className="block text-sm font-bold text-gray-300 mb-2" data-id="element-84">
                  {t.contact.form.msg}
                </label>
                <textarea rows={4} className="w-full px-4 py-3 rounded-sm bg-white/10 border border-white/20 text-white placeholder-gray-500 focus:border-brand-gold focus:ring-2 focus:ring-brand-gold/20 outline-none transition-all" data-id="element-85"></textarea>
              </div>

              <button type="submit" className="w-full bg-brand-red hover:bg-brand-darkred text-white font-bold text-lg py-4 rounded-sm transition-colors shadow-lg shadow-brand-red/30" data-id="element-86">
                {t.contact.form.submit}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}